module.exports = __webpack_public_path__ + "static/media/DedicatedPlatform.406d8667.svg";